import Icon from '@/components/ui/AppIcon';

const DisclaimerSection = () => {
  return (
    <div className="bg-card rounded-xl shadow-elevation-md p-6 space-y-6">
      <div className="flex items-center space-x-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-warning/10">
          <Icon name="InformationCircleIcon" size={24} className="text-warning" />
        </div>
        <h3 className="font-heading text-lg font-semibold text-text-primary">
          Important Pricing Information
        </h3>
      </div>

      <div className="space-y-4">
        <div className="rounded-lg bg-warning/5 border border-warning/20 p-4">
          <div className="flex items-start space-x-3">
            <Icon name="ExclamationTriangleIcon" size={20} className="text-warning flex-shrink-0 mt-0.5" />
            <div className="flex-1">
              <p className="font-caption text-xs font-medium text-text-primary mb-2">
                Pricing Estimates Only
              </p>
              <p className="font-body text-xs text-text-secondary leading-relaxed">
                All prices shown are estimates based on local market research and typical service costs. Actual prices may vary based on vehicle condition, parts availability, specific model requirements, and individual shop rates.
              </p>
            </div>
          </div>
        </div>

        <div className="space-y-3">
          <div className="flex items-start space-x-3">
            <Icon name="DocumentTextIcon" size={18} className="text-muted-foreground flex-shrink-0 mt-0.5" />
            <div className="flex-1">
              <p className="font-body text-sm font-medium text-text-primary mb-1">
                Get Actual Quotes
              </p>
              <p className="font-body text-xs text-text-secondary leading-relaxed">
                We strongly recommend obtaining written quotes from multiple mechanics before proceeding with any repair. This ensures accurate pricing for your specific vehicle and service needs.
              </p>
            </div>
          </div>

          <div className="flex items-start space-x-3">
            <Icon name="MapPinIcon" size={18} className="text-muted-foreground flex-shrink-0 mt-0.5" />
            <div className="flex-1">
              <p className="font-body text-sm font-medium text-text-primary mb-1">
                Local Market Variations
              </p>
              <p className="font-body text-xs text-text-secondary leading-relaxed">
                Pricing reflects local market conditions. Labor rates and parts costs may vary by location, shop specialization, and current market conditions.
              </p>
            </div>
          </div>

          <div className="flex items-start space-x-3">
            <Icon name="ChartBarIcon" size={18} className="text-muted-foreground flex-shrink-0 mt-0.5" />
            <div className="flex-1">
              <p className="font-body text-sm font-medium text-text-primary mb-1">
                Data Sources
              </p>
              <p className="font-body text-xs text-text-secondary leading-relaxed">
                Pricing data compiled from local local dealership service departments, independent repair shops, and industry pricing guides. Updated regularly to reflect current market conditions.
              </p>
            </div>
          </div>

          <div className="flex items-start space-x-3">
            <Icon name="ShieldExclamationIcon" size={18} className="text-muted-foreground flex-shrink-0 mt-0.5" />
            <div className="flex-1">
              <p className="font-body text-sm font-medium text-text-primary mb-1">
                No Liability
              </p>
              <p className="font-body text-xs text-text-secondary leading-relaxed">
                AutoFixIQ provides pricing information for educational purposes only. We are not responsible for actual service costs, quality of work, or any disputes between customers and service providers.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="pt-4 border-t border-border">
        <p className="font-body text-xs text-text-secondary text-center leading-relaxed">
          Last updated: January 2026 • Pricing reflects current local market conditions
        </p>
      </div>
    </div>
  );
};

export default DisclaimerSection;